import {
  EMPLOYEES_REQUEST, EMPLOYEES_SUCCESS,
  EMPLOYEES_STATUS_REQUEST, EMPLOYEES_STATUS_SUCCESS,
  USER_STATUS_REQUEST, USER_STATUS_SUCCESS,
  EMPLOYEE_EXPAND,
  EMPLOYEES_ADMIN_STATUS_REQUEST, EMPLOYEES_ADMIN_STATUS_SUCCESS
} from '../../constants/actionTypes';
import {getApiConfig} from '../../utilities/index';

const getEmployeesMethod = getApiConfig('Users/GetEmployees');
const changeUserStatusMethod = getApiConfig('Users/EnableUser');
const changeEmployeeStatusMethod = getApiConfig('Users/EnableEmployee');
const changeEmployeeAdminStatusMethod = getApiConfig('Users/EnableEmployeeAdminRights');

export const getEmployees = (page = 0, pageSize = 50, searchKeyword = '') => {
  return dispatch => {
    dispatch({type: EMPLOYEES_REQUEST, searchKeyword});
    const data = {
      page,
      pageSize
    };
    if (searchKeyword) {
      data.FilterBy = {
        filter: searchKeyword
      }
    }
    getEmployeesMethod.post(data)
      .then(data => {
        dispatch({type: EMPLOYEES_SUCCESS, data})
      })
  }
};

export const changeEmployeeStatus = (userId, fabricatorId, enabled, isPrimaryProfile) => {
  return dispatch => {
    dispatch({type: EMPLOYEES_STATUS_REQUEST});

    changeEmployeeStatusMethod.post({userId, fabricatorId, enabled, isPrimaryProfile})
      .then(() => {
        dispatch({type: EMPLOYEES_STATUS_SUCCESS, success: true})
      })
  }
};

export const changeEmployeeAdminStatus = (userId, fabricatorId, enabled) => {
  return dispatch => {
    dispatch({type: EMPLOYEES_ADMIN_STATUS_REQUEST});

    changeEmployeeAdminStatusMethod.post({userId, fabricatorId, enabled})
      .then(() => {
        dispatch({type: EMPLOYEES_ADMIN_STATUS_SUCCESS, success: true})
      });
  }
};

export const changeUserStatus = (userId, enabled) => {
  return dispatch => {
    dispatch({type: USER_STATUS_REQUEST});

    changeUserStatusMethod.post({userId, enabled})
      .then(() => {
        dispatch({type: USER_STATUS_SUCCESS})
      });
  }
};

export const expandEmployee = (employeeId) => {
  return dispatch => {
    dispatch({
      type: EMPLOYEE_EXPAND,
      payload: employeeId
    })
  }
};
